export default __webpack_public_path__ + "static/button-action-dont-6daa44bbbd1e3ee0a89505f30fa6712e57e62450a250494dd6e9189b254e528c.png";